import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-743b08f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "my-order-page"
};
const _hoisted_2 = {
  class: "my-order-wrap"
};
import NavBar from '@/components/NavBar/NavBar.vue';
import OrderList from './components/OrderList.vue';
import OrderFilter from './components/OrderFilter.vue';
import { useOrderConfig } from './components/useOrderConfig';
import { queryOrderDetailListApi } from '@/api/myOrder';
import { fullScreen, openLoginPage } from '@/utils/navitiveApi/common';
import { ref, getCurrentInstance, onMounted, computed, provide } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MyOrder',
  setup(__props) {
    var _getCurrentInstance$p, _getCurrentInstance;
    const {
      $alert,
      $loading
    } = (_getCurrentInstance$p = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.proxy) !== null && _getCurrentInstance$p !== void 0 ? _getCurrentInstance$p : {};
    const pageMode = ref('1'); // 页面类型，目前不分产寿，之后可能调整
    const currentTab = ref('active'); // 当前标签页
    const orderList = ref([]);
    const isFirst = ref(0);
    const {
      getOrderFilter
    } = useOrderConfig({});
    // 根据tab页筛选
    const filtList = computed(() => status => getOrderFilter(status, orderList.value));
    const getOrderList = async refresh => {
      isFirst.value = 1;
      !refresh && $loading.openLoading();
      try {
        const {
          code,
          message,
          data
        } = await queryOrderDetailListApi({
          userId: ''
        });
        !refresh && $loading.closeLoading();
        if (code !== 9000) {
          $alert({
            message
          }).then(() => {
            if (code === 9008) {
              openLoginPage();
            }
          });
          return;
        }
        orderList.value = data;
      } catch (error) {
        console.error(error);
      }
    };
    provide('reloadList', refresh => {
      return getOrderList(refresh);
    });
    // watch(
    //     () => router.currentRoute.value.path,
    //     toPath => {
    //         console.info('监听路由 myOrder', toPath)
    //         fullScreen()
    //         getOrderList()
    //     },
    //     { immediate: true, deep: true },
    // )
    function handlePageShow() {
      console.info('页面pageShow事件触发了');
      fullScreen();
      if (isFirst.value === 0) {
        getOrderList();
      }
    }
    function handlePageHide() {
      console.info('页面pageHide事件触发了 isFirst', isFirst.value);
      isFirst.value = 0;
      console.info('赋值 isFirst', isFirst.value);
    }
    const onShow = () => {
      console.info('onShow触发了');
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('pagehide', handlePageHide);
      window.addEventListener('pageshow', handlePageShow);
      window.addEventListener('pagehide', handlePageHide);
    };
    onShow();
    onMounted(() => {
      fullScreen();
      getOrderList();
    });
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavBar, {
        title: "我的订单",
        "back-to-close": ""
      }), _createElementVNode("div", _hoisted_2, [pageMode.value === '1' ? (_openBlock(), _createBlock(_component_van_tabs, {
        key: 0,
        active: currentTab.value,
        "onUpdate:active": _cache[0] || (_cache[0] = $event => currentTab.value = $event),
        class: "sinosig-tab",
        animated: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          class: "my-order-tabs",
          title: "进行中",
          name: "active"
        }, {
          default: _withCtx(() => [_createVNode(OrderList, {
            "data-list": _unref(filtList)('active')
          }, null, 8, ["data-list"])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "已完成",
          name: "finished"
        }, {
          default: _withCtx(() => [_createVNode(OrderList, {
            "data-list": _unref(filtList)('finished')
          }, null, 8, ["data-list"])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "已关闭",
          name: "closed"
        }, {
          default: _withCtx(() => [_createVNode(OrderList, {
            "data-list": _unref(filtList)('closed')
          }, null, 8, ["data-list"])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "全部",
          name: "all"
        }, {
          default: _withCtx(() => [_createVNode(OrderList, {
            "data-list": orderList.value
          }, null, 8, ["data-list"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["active"])) : _createCommentVNode("", true), pageMode.value === '2' ? (_openBlock(), _createBlock(_component_van_tabs, {
        key: 1,
        active: currentTab.value,
        "onUpdate:active": _cache[1] || (_cache[1] = $event => currentTab.value = $event),
        class: "sinosig-tab"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: "产险",
          name: "a"
        }, {
          default: _withCtx(() => [_createVNode(OrderFilter), _createVNode(OrderList, {
            "data-list": orderList.value
          }, null, 8, ["data-list"])]),
          _: 1
        }), _createVNode(_component_van_tab, {
          title: "寿险",
          name: "b"
        }, {
          default: _withCtx(() => [_createVNode(OrderFilter), _createVNode(OrderList, {
            "data-list": orderList.value
          }, null, 8, ["data-list"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["active"])) : _createCommentVNode("", true)])]);
    };
  }
});